<script setup lang="ts">
export type BlockCarouselItem = {
    icon?: string;
    title?: string;
    description?: string;
};

// PROPS
defineProps({
    items: { type: Array as PropType<BlockCarouselItem[]>, required: true },
});
</script>

<template>
    <UCarousel
        v-slot="{ item, index }"
        :items="items"
        arrows
        :ui="{
            item: 'justify-center basis-full md:basis-1/2 lg:basis-1/4',
            container: 'gap-x-4',
            arrows: '-bottom-4 data-disabled:bg-neutral-400 data-active:bg-neutral-800',
        }"
        class="w-full"
        dots
    >
        <slot v-if="item" :item="item" :index="index">
            <BlockCarouselItem v-bind="item" class="max-w-[248px]" />
        </slot>
    </UCarousel>
</template>
